import React from 'react';

import {
  ELocationSearchAutocompleteListVariant,
  LocationSearchAutocompleteList,
} from '@/components/common/LocationSearchAutocompleteList';
import { calculateOptionIndex, IGroupOption, IOption } from '@/utility/autoCompleteGroupedOptions';

import LocationNotice from '../../components/LocationNotice';

interface ILocationSearchContentProps {
  open: boolean;
  groupOptions: IGroupOption[];
  allGroupOptions: IGroupOption[];
  getListboxProps: () => Record<string, unknown>;
  getOptionProps: ({
    option,
    index,
  }: {
    option: IOption;
    index: number;
  }) => Record<string, unknown>;
  isDelivery: boolean;
}

const LocationSearchContent: React.FC<ILocationSearchContentProps> = ({
  open,
  groupOptions,
  allGroupOptions,
  getListboxProps,
  getOptionProps,
  isDelivery,
}) => {
  return (
    <>
      {isDelivery && <LocationNotice />}
      <div className={`p-6 bg-white ${open ? 'block' : 'hidden'}`} {...getListboxProps()}>
        <LocationSearchAutocompleteList
          groupedOptions={groupOptions}
          getOptionProps={({ option, index }) =>
            getOptionProps({
              option,
              index: calculateOptionIndex(option.groupName, index, allGroupOptions),
            })
          }
          variant={ELocationSearchAutocompleteListVariant.Horizontal}
        />
      </div>
    </>
  );
};

export default LocationSearchContent;
